import { Flex, Text } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClone } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  manuscriptId: string;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const CloneSubmissionModal = ({
  manuscriptId,
  isLoading = false,
  onClose,
  onConfirm
}: Props) => {
  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      width="448px"
      closeButtonProps={{ hidden: true }}
    >
      <Flex flexDirection="column" gap={6} padding={8}>
        <FontAwesomeIcon icon={faClone} style={{ width: '40px', height: '40px' }} />

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Clone Submission?</Text>
          <Text textStyle="textBody">
            You are about to create a copy of submission {manuscriptId}. Do you
            want to continue?
          </Text>
        </Flex>

        <Flex justifyContent="flex-end" gap={2}>
          <Button variant="secondary" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            disabled={isLoading}
            isLoading={isLoading}
          >
            Clone Submission
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default CloneSubmissionModal;
